import searchBar from '../../md-search-bar/_store';
import { mergeModules } from '@/store/helpers';

export default mergeModules(searchBar);
